export default "/images/vendor/flag-icons/flags/1x1/gb-eng.svg?7b249f565cc9aa70b36bcdee11fd25e0";